/**
 * Error Reporter Utility
 * Provides clean interface for handling and reporting collateral preview errors
 */

/**
 * Formats an error message for chatbot reporting
 * @param {string} errorMessage - Raw error message from LiveError
 * @returns {string} Formatted error message suitable for chatbot
 */
export const formatErrorForChatbot = (errorMessage) => {
  if (!errorMessage) return '';
  
  // Clean up the error message
  let formatted = errorMessage.trim();
  
  // Add context prefix
  const prefix = 'Getting the following error in the collateral :\n\n';
  
  return `${prefix}\`\`\`\n${formatted}\n\`\`\``;
};

/**
 * Extracts meaningful error details from error message
 * @param {string} errorMessage - Raw error message
 * @returns {Object} Extracted error details
 */
export const extractErrorDetails = (errorMessage) => {
  if (!errorMessage) {
    return {
      type: 'unknown',
      message: '',
      component: null,
      line: null,
    };
  }

  // Try to extract error type (ReferenceError, TypeError, etc.)
  const errorTypeMatch = errorMessage.match(/^(\w+Error):/);
  const errorType = errorTypeMatch ? errorTypeMatch[1] : 'Error';

  // Try to extract component name
  const componentMatch = errorMessage.match(/is not defined|Cannot read property|Cannot access/);
  
  // Try to extract line number if available
  const lineMatch = errorMessage.match(/line (\d+)/);

  return {
    type: errorType,
    message: errorMessage,
    component: componentMatch ? componentMatch[0] : null,
    line: lineMatch ? parseInt(lineMatch[1]) : null,
  };
};

